import * as React from "react";
import { Typography, Box } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { InformationGrid } from "@/components/dashboard/InformationGrid";
import { TradeSummarySection } from "@/components/trades/sections/TradeSummarySection";
import { TradesTableSection } from "@/components/trades/sections/TradesTableSection";

export function TradesPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Trades
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Read-only view of Falcon's recorded trade book — no order actions.
        </Typography>
      </Box>
      <InformationGrid>
        <TradeSummarySection />
      </InformationGrid>
      <Box sx={{ mt: 3 }}>
        <TradesTableSection />
      </Box>
    </ResponsiveContainer>
  );
}
